/** Uniform keyboard focus ring for focusable elements. */
export const focusVisibleOutline =
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background';

/** Inset ring drawn above tile content. The stretched link is under `z-20` controls, so its own outline is covered. */
export const productCardFocusRingClass =
    'pointer-events-none absolute inset-0 z-30 rounded-[inherit] opacity-0 ring-2 ring-inset ring-ring peer-focus-visible:opacity-100';
